import { render, staticRenderFns } from "./xyhdDetail.vue?vue&type=template&id=570b9454&scoped=true&"
import script from "./xyhdDetail.vue?vue&type=script&lang=js&"
export * from "./xyhdDetail.vue?vue&type=script&lang=js&"
import style0 from "./xyhdDetail.vue?vue&type=style&index=0&id=570b9454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b9454",
  null
  
)

export default component.exports